<div class="dialog-default">
    <h1 *ngIf="data.title" mat-dialog-title>{{data.title}}</h1>
    <p *ngIf="data.message">{{data.message}}</p>
    <div class="d-flex flex-row justify-content-end">
        <button (click)="no()" class="btn btn-secondary my-2 mx-2" type="button">{{data.no ? data.no : 'Non'}}</button>
        <button (click)="yes()" class="btn btn-primary my-2 mx-2" type="button">{{data.yes ? data.yes : 'Oui'}}</button>
    </div>
</div>
